import React from 'react';

export const FormLayout = ({ fields, error, buttons }) => (
  <form>
    {fields.toList()}
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);
